import { usePolicyOutletContext } from "~/components/policy-gql/policy-gql";
import { PolicyProperties } from "./components/PolicyProperties";

export type PolicyDetailPropertiesPageProps = {};

export function PolicyDetailPropertiesPage({}: PolicyDetailPropertiesPageProps) {
  const { space, policyId } = usePolicyOutletContext();
  return <PolicyProperties space={space} policyId={policyId} />;
}
